import React from 'react';
import { t } from '../../../services/i18nService';
import styles from './compulsoryFrameLabel.scss';

const CompulsoryFrameLabel = () => {
    return (<div className={styles.compulsoryFrameTitleWrapper}>
        <span className={styles.compulsoryFrameTitle}>{t('question.alternativeFrameLabel')}</span>
    </div>);
};

export default CompulsoryFrameLabel;
